import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseService } from 'src/app/core/models/response-service.model';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CallerBackendService {
	constructor(private http: HttpClient) {}

	public getCampaignsToCall(user_id: number) {
		const url = `${environment.api}campaign/${user_id}/get_campaigns_to_call`;
		return this.http.get<ResponseService>(url);
	}
}
